import React from 'react';
import { Star, Shield, Send, ArrowRight } from 'lucide-react';
import { formatPartnerSpecialtyLine } from '../../utils/maintenanceTicketJobOrderUtils';

const PreferredPartnerCallout = ({ partner, content, onNotify }) => {
  if (!partner) return null;

  const specialtyLine = formatPartnerSpecialtyLine(content, partner);
  const notifyLabel = `Notify ${partner.name}`;

  return (
    <div className="mb-6 p-4 rounded-xl border-2 border-primary-200 bg-gradient-to-br from-primary-50 to-primary-100/60">
      <div className="flex items-start gap-4">
        <div className="p-2.5 rounded-lg bg-primary-100 shrink-0">
          <Star className="size-5 text-primary-700 fill-primary-200" strokeWidth={2} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1 flex-wrap">
            <span className="text-xs font-semibold text-primary-800 uppercase tracking-wide">
              Preferred Response Partner
            </span>
            <span className="inline-flex items-center gap-1 text-[10px] font-medium px-2 py-0.5 rounded-full border border-primary-300 text-primary-800 bg-white/80">
              <Shield className="size-2.5" strokeWidth={2} />
              Verified
            </span>
          </div>
          <h4 className="text-base font-semibold text-gray-900 mb-1">{partner.name}</h4>
          {partner.description && (
            <p className="text-sm text-gray-600 mb-1">{partner.description}</p>
          )}
          {specialtyLine && (
            <p className="text-sm text-gray-500 mb-3">{specialtyLine}</p>
          )}
          <div className="flex items-center gap-3 flex-wrap">
            <button
              type="button"
              onClick={onNotify}
              className="inline-flex items-center gap-2 ml-0 px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold transition-colors shadow-sm"
            >
              <Send className="size-4" strokeWidth={2} />
              {notifyLabel}
              <ArrowRight className="size-4" strokeWidth={2} />
            </button>
            <span className="text-xs text-gray-500">One-click email dispatch</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreferredPartnerCallout;
